import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import api from "@/lib/api";

const NotificationContext = createContext(null);

export function NotificationProvider({ children }) {
  const [data, setData] = useState({ notifications: [], unread: 0 });

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/notifications");
      setData(data);
    } catch {}
  }, []);

  useEffect(() => {
    refresh();
    const t = setInterval(refresh, 30000);
    return () => clearInterval(t);
  }, [refresh]);

  const markOne = async (id) => { await api.post(`/notifications/${id}/read`); refresh(); };
  const markAll = async () => { await api.post("/notifications/read-all"); refresh(); };

  return (
    <NotificationContext.Provider value={{ ...data, refresh, markOne, markAll }}>
      {children}
    </NotificationContext.Provider>
  );
}

export const useNotifications = () => useContext(NotificationContext);
